export default (refId: string, root: string) => {
  return {
    refId,
    root,
    status: null,
    due: '',
    comment: '',
    responsible: 0,
    responsibleName: '',
    author: 0,
    history: [],
  };
};
